<template>
  <div class="setting-panel" :style="settingStyle" >
    <div class="swap-setting-panel">
      <div @click="swapPanel" :class="{'pack-up': this.collapse}">
        <i :class="[collapse ? 'arrow-left' : 'arrow-right']"></i>
      </div>
    </div>
    <div class="setting-content">
      <div class="content-header">
        <div v-for="v, i in header" :class="{'active': v.active}">
          <div @click="changeSetType(v, i)">{{v.name}}</div>
        </div>
      </div>
      <div v-if="type === 'background'" class="content-body">
        <BgSetting :active="header[0].active" />
        <LayerSetting :active="header[1].active" />
      </div>
      <div v-else-if="type === 'sprites'" class="content-body">
        <SpritesSetting :active="header[0].active" />
        <EffectSetting :active="header[1].active" />
      </div>
    </div>
    <transition name="slide-right">
      <div class="version-control" v-if="VersionControlShow || BackupControlShow" style="z-index: 1;">
        <transition-group name="el-fade-in">
          <VersionControl v-if="VersionControlShow && !IsPrivateDraft" key="0"></VersionControl>
          <DraftVersionControl v-if="VersionControlShow && IsPrivateDraft" key="1"></DraftVersionControl>
          <!-- <CooperationBackup v-if="BackupControlShow && cooperationDraftOwnerId" key="2"></CooperationBackup> -->
          <BackupControl v-if="BackupControlShow" key="3"></BackupControl>
        </transition-group>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BgSetting from './settingPanel/bgSetting.vue'
import LayerSetting from './settingPanel/layerSetting.vue'
import SpritesSetting from './settingPanel/spritesSetting.vue'
import EffectSetting from './settingPanel/effectSetting.vue'
import VersionControl from '@/components/versionControl/VersionControl.vue'
import DraftVersionControl from '@/components/versionControl/DraftVersionControl.vue'
import BackupControl from '@/components/versionControl/BackupControl.vue'
import CooperationBackup from '@/components/versionControl/CooperationBackup.vue'

export default {
  data() {
    return {
      collapse: false,
      type: 'background',
      header: [{type: 'background', name: '页面属性', active: true}, {type: 'layer', name: '图层管理', active: false}],
      background: {},
      headerArr: [
        [{type: 'background', name: '页面属性', active: true}, {type: 'layer', name: '图层管理', active: false}],
        [{type: 'style', name: '样式属性', active: true}, {type: 'action', name: '动画设置', active: false}]
      ]
    }
  },
  computed: {
    ...mapGetters([
      'TOOL',
      'SetPanel_Size',
      "SelectScenes_Msg",
      "SelectSprites_Msg",
      'cooperationDraftOwnerId',
      'IsPrivateDraft'
    ]),
    ...mapGetters({
      VersionControlShow: 'versionControl/VersionControlShow',
      BackupControlShow: 'draftBackup/isShowUI',
      openSubtitle : "subtitle/openSubtitle"
    }),
    settingStyle() {
      const style = {};
      style.width = this.SetPanel_Size.width + 'px';
      style.height = this.SetPanel_Size.height + "px";
      style.top = this.SetPanel_Size.top + "px";
      style.opacity = this.openSubtitle ? 0 : 1
      return style;
    }
  },
  watch: {
    SelectSprites_Msg () {
      if(this.SelectSprites_Msg) {
        this.type = 'sprites';
        this.header = this.headerArr[1];
      } else {
        this.type = 'background';
        this.header = this.headerArr[0];
      }
    }
  },
  mounted () {

  },
  methods: {
    swapPanel() {
      this.collapse = !this.collapse;
      this.$store.commit('save_SetPanel', {width: this.collapse ? 14 : 260});
      this.$bus.emit("EditorSetOption_vue", {
        data: true,
        source: "settingPanel"
      });
      if (this.collapse) {
        this.$store.commit("versionControl/set_VersionControlShow", false);
        this.$store.commit("draftBackup/isShowUI", false);
      }
    },
    changeSetType(v, i) {
      let j = (i + 1) % 2;
      this.header[i].active = true;
      this.header[j].active = false;
    }
  },
  components: {
    BgSetting,
    LayerSetting,
    SpritesSetting,
    EffectSetting,
    VersionControl,
    DraftVersionControl,
    BackupControl
  }
}
</script>

<style lang="scss" scoped>
@import '../style/transition';
.setting-panel {
  position: absolute;
  right: 0;
  top: 60px;
  z-index: 10;
  transition: all 0.3s;
}
.swap-setting-panel {
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  align-items: center;
  justify-content: flex-end;
  width: 17px;
  height: 100%;
  background: rgb(239, 241, 248);
  box-shadow: inset -3px 0px 4px -4px rgba(33,36,51,0.2);

  i {
    display: block;
    width: 6px;
    height: 10px;
    margin-left: 8px;
  }

  div {
    display: flex;
    align-items: center;
    width: 17px;
    height: 55px;
    background: url("../../static/svg/pane-arrow-right.svg") no-repeat center;
    &.pack-up {
      background: url("../../static/svg/pane-arrow-right-packed.svg") no-repeat center;
    }
    cursor: pointer;

    &:hover {
      .arrow-left {
        background: url('../../static/svg/left-arrow.svg') no-repeat center;
      }
      .arrow-right {
      background: url('../../static/svg/right-arrow.svg') no-repeat center;
    }
    }
  }

  .arrow-left {
    background: url('../../static/svg/left-arrow-active.svg') no-repeat center;    
  }
  .arrow-right {
    background: url('../../static/svg/right-arrow-active.svg') no-repeat center;
  }
}
.setting-content,
.version-control {
  position: absolute;
  width: 243px;
  height: 100%;
  top: 0;
  left: 17px;
  background: #fff;
  overflow: hidden;
}
.content-header {
  width: 223px;
  height: 40px;
  margin: 10px;
  display: flex;
  align-items: center;
  justify-content: space-around;

  div div {
    width: 111px;
    border-bottom: 2px solid #D4D4E7;
    line-height: 40px;
    cursor: pointer;
    color: #474261;

    &:hover {
      font-weight: bold;
    }
  }

  .active div {
    border-bottom: 2px solid #5778FB;
    font-weight: bold;
  }
}
.content-body {
  position: relative;
  left: 0;
  top: 0;
  margin-left: 10px;
  width: calc(100% + 20px);
  height: calc(100% - 50px);
  overflow-y: scroll;
  overflow-x: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/settingPanel.vue